define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Marionette = require('marionette');
    var Backbone = require('backbone');
    var ItemNewTpl = require('text!components/menu/itemNew.tpl').default;
    var I18n = require('i18n!nls/main');

    return Marionette.ItemView.extend({
        tagName: 'li',
        template: ItemNewTpl,
        className: function() {
            return this.model.get('fixed') ? 'fixed' : '';
        },

        events: {
            //'click a': 'clickToItem'
        },

        lastLink: null,

        initialize: function () {
            var submenu = this.model.get('submenu');
            var url = this.model.get('url');

            if (submenu && submenu.length) {
                this.model.set('submenu', _.sortBy(submenu, 'order'));
                _.each(submenu, function (item) {
                    var subMenuTitle = I18n.staff.accessPagesList[item.title];
                    if (!subMenuTitle) subMenuTitle = item.title;
                    item.hide = app.checkAccess(subMenuTitle);
                });
            }

            var firstVisibleSubmenu = _.find(submenu, {hide:false});
            if (submenu && firstVisibleSubmenu) {
                this.model.set('link', firstVisibleSubmenu.link);
            }

            if (url) {
                if (app.Models.Counters.get(url)) {
                    this.model.set('count', app.Models.Counters.get(url));
                }
                this.listenTo(app.Models.Counters, 'change:' + url, this.onCounterChange);
            }

            $(window).resize(this.onWindowResize);
        },

        allowGoTo: function(e){
            var that        = this;
            var target      = $(e.currentTarget);
            var childTarget = $(e.target).closest('a');
            var href        = '';
            var allow       = true;

            if(target.attr('href') !== undefined) {
                href += target.attr('href');
            } else {
                href += childTarget.attr('href');
            }

            if(href.length == 1){
                if(href[0] == '#'){
                    href = '';
                }
            }else{
                if(href[0] == '#'){
                    href = href.substring(1);
                }
            }

            if(href.length > 0){
                if(that.lastLink == null){
                    that.lastLink = href;
                    return true;
                }else{
                    if(that.lastLink != href){
                        that.lastLink = href;
                        return true;
                    }else if(that.lastLink == href){
                        return true;
                    }else {
                        return false;
                    }
                }
            }

            return allow;
        },

        serializeData: function() {
            var data = this.model.toJSON();

            data.height = data.height || '40px';
            data.width = data.width || '40px';
            data.color = data.color || '#cccccc';
            data.color_active = data.color_active || '#ffffff';
            return data;
        },

        onRender: function () {
            app.Rivets.bind(this.el, {model: this.model});
        },

        clickToItem: function (event) {
            var $el = $(event.target).closest('a');
            var href = $el.attr('href');

            if(this.allowGoTo(event)){
                if (href && href != '#') {
                    $('#sidebar-content').removeClass('menu-hovered');
                    var newFragment = Backbone.history.getFragment($el.attr('href'));
                    if (Backbone.history.fragment == newFragment) {
                        Backbone.history.fragment = null;
                        Backbone.history.navigate(newFragment, true);
                    }
                }
            }
        },

        onCounterChange: function(model, value) {
            var needShow    = false;
            var valueInt    = parseInt(value, 10);
            if(!isNaN(valueInt) && valueInt > 0){
                needShow = true;
            }
            this.$('.counter').text(value);
            if(needShow){
                this.$('.counter').show();
            }else{
                this.$('.counter').hide();
            }
            this.model.set('count', value);
        },

        onWindowResize: function(event) {
            if (window.innerWidth > 700) {
                $('body').removeClass('sidebar-opened');
            }
        },

        onDestroy: function() {
            $(window).off('resize', this.onWindowResize);
        }
    });

});
